export const mapKey = 'WxDouUltFmSyBeS9FpXLZYB3GeLkKid7w_UYEnmlF2c';